import { render, staticRenderFns } from "./skillslist.vue?vue&type=template&id=72e844c3&scoped=true&"
import script from "./skillslist.vue?vue&type=script&lang=js&"
export * from "./skillslist.vue?vue&type=script&lang=js&"
import style0 from "./skillslist.vue?vue&type=style&index=0&id=72e844c3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72e844c3",
  null
  
)

export default component.exports